<template>
  <div class="container container-table" id="updatePassword">
    <div class="row">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-solid box-info">
            <div>
              <div class="box-body">
                <div class="row">
                  <div style="width:224px;margin:auto;">
                    <img src="../../src/assets/img/account/developer.png" class="center-block1">
                  </div>
                  <div style="test_all">
                    <div class="text-center col-md-4 col-sm-offset-4 container">
                      <form class="ui form loginForm container">
                        <div class="mail-02">
                          <img
                            class="mail-02_image"
                            src="../../src/assets/img/account/gra-account-check.jpg"
                            alt
                          >
                        </div>
                        <div class="Youre-almost-ready">
                          <p class="account_setup_comple">{{ $t('account.common.AuthenticationCompleted.content.success') }}</p>
                          <p class="updatedLogin">{{ $t('account.common.UpdatePasswordSucess.content.updated') }}</p>
                        </div>
                        <div class="divBtnletter">
                          <button class="btnLetterCompeleted" @click="enterNow">{{ $t('account.common.UpdatePasswordSucess.content.login') }}</button>
                          <span class="btn_login_border"></span>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Login',
    data (router) {
        return {
            section: 'Login',
            response: ''
        }
    },
    mounted () {
        this.$store.state.isFooterShow = false
    },
    methods: {
        enterNow () {
            this.$router.push({ name: 'userLogin' })
        }
    },
    destoryed () {
        this.$store.state.isFooterShow = true
    }
}
</script>

<style scoped>
#updatePassword {
    font-family: sans-serif;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    font-size: 14px;
}

.updatedLogin {
    width: 345px;
    height: 46px;
    font-family: sans-serif;
    font-size: 12px !important;
    letter-spacing: 0.7px;
    color: var(--black);
    margin-top: 12px !important;
}
.btn_login_border {
    width: 145px;
    height: 0.1px;
    border: solid 1.2px rgba(51, 51, 51, 0.3);
    position: absolute;
    left: 145px;
    top: 48px;
}
.divBtnletter {
    margin-top: 35px;
    position: relative;
    text-align: center;
}
.btnLetterCompeleted {
    width: 165px;
    height: 50px;
    border-radius: 10px;
    background-color: #00b5e2;
    outline: none;
    border: none;
    font-family: sans-serif;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
}

.account_email_image {
    width: 22px;
    height: 20px;
    margin-left: 4px;
    margin-right: 9px;
}
.Youre-almost-ready {
    width: 428px;
    letter-spacing: 0.8px;
    color: #333333;
    margin-left: 74px;
    text-align: left;
    margin-top: 36px;
}
.account_setup_comple {
    width: 345px;
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.9px;
    color: var(--black);
}
.Youre-almost-ready p {
    margin: 0;
}
.Youre-almost-ready a {
    margin-bottom: 20px;
    text-align: left;
    display: inline-block;
    color: #00b5e2;
}
.email_account {
    padding-top: 20px;
}
.div_span_border {
    position: relative;
    margin-top: 34px;
}
.span_border {
    width: 280px;
    height: 0.1px;
    border: solid 0.8px rgba(51, 51, 51, 0.3);
    position: absolute;
    left: 105px;
    bottom: 0;
}
.normal {
    width: 306px;
    height: 50px;
    border-radius: 10px;
    background-color: #00b5e2;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 1.2px;
    text-align: center;
    color: #ffffff;
    outline: none;
    border: none;
    cursor: pointer;
}
.mail-02_image {
    width: 100%;
    height: 100%;
}
.mail-02 {
    width: 170px;
    margin: auto;
    margin-top: 30px;
}
.Remember_me_image {
    width: 100%;
    height: 100%;
}
.div_creat_account {
    width: 30.7em;
    height: 5.57em;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.3);
    border: solid 2.5px rgba(0, 181, 226, 0.5);
    margin: auto;
    margin-top: 13.5em;
    margin-bottom: -20.6em;
    cursor: pointer;
}
.span_creat_account {
    width: 21.4em;
    height: 2.35em;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 1.2px;
    text-align: center;
    color: #00b5e2;
    line-height: 3em;
}
.error_response_p {
    margin: 0;
}
html,
body,
.container-table {
    height: 100%;
    background-color: white !important;
}
.container-table {
    display: table;
    color: white;
    width: 72%;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
    padding-top: 20%;
}
.vertical-10p {
    padding-top: 10%;
}
.logo {
    width: 15em;
    padding: 3em;
}
.loginForm .input-group {
    padding-bottom: 1em;
    height: 0;
}
.input-group input {
    height: 2.7em;
}
#userLoginSubmitButton {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    height: 100%;
    outline: none;
}
/* [fu] */

/* 取消边框 */
.box.box-solid.box-info {
    border: none;
}
.vertical-10p {
    padding-top: 3.5em !important;
}
.center-block1 {
    padding-bottom: 3.5em !important;
    margin-top: 50px;
}
.box-body {
    padding-top: 0;
}
/* input */
.input-group input {
    width: 23.8em !important;
    border-radius: 12px !important;
    border: 1px solid rgba(51, 51, 51, 0.5);
    color: #333333;
}
.input-group {
    margin: auto;
    font-weight: bold;
}
/* form剧中 */
.col-sm-offset-4 {
    margin: auto;
    width: 100%;
}
.checkbox_div {
    display: flex;
    margin-left: 2em;
    margin-bottom: 3.5em;
    width: 23.8em;
    margin: auto;
    padding-bottom: 2.8em;
    margin-top: 0.3em;
    position: relative;
}
/* 这是button */
.btn-info {
    background-color: rgba(51, 51, 51, 0.2);
    border: none;
    width: 10em !important;
    margin-left: 33%;
    border-radius: 8px !important;
    font-size: 22px !important;
    height: 50px !important;
    margin-bottom: 1.5em !important;
    margin: auto;
}
.div_signin {
    width: 37em;
    padding-top: 2.4em;
    margin: auto;
}

/* input的字体大小 */
.form-control {
    padding: 6px 24px;
    font-size: 18px;
}
.Forget_password {
    height: 20px;
    letter-spacing: 0.8px;
    color: #333333;
}
.Remember_me {
    line-height: 19px;
    letter-spacing: 0.8px;
    color: #333333;
    padding-left: 10px;
}
.Remember_me {
    cursor: pointer;
}
.checkbox_class {
    cursor: pointer;
}
.Forget_password {
    cursor: pointer;
}
/* 加form的上下border */
.ui {
    width: 31em;
    border-bottom: none;
    border-top: 2px solid rgba(51, 51, 51, 0.1);
    padding-top: 5px;
    padding-bottom: 0;
}
.box {
    box-shadow: none;
    margin-bottom: 0;
}
.box-body {
    padding-bottom: 0;
}
.Join-NUWA-developer {
    width: 164px;
    height: 20px;
    letter-spacing: 0.8px;
    color: rgba(51, 51, 51, 0.5);
    margin: auto;
    padding-top: 2.7em;
}
.input_form {
    width: 380px;
    letter-spacing: 1.2px;
    color: rgba(51, 51, 51, 0.3);
}
.div_footer {
    display: flex;
    clear: both;
    margin: auto;
    padding-top: 25.5em;
    width: 57em;
}
#app {
    background: rgba(0, 181, 226, 0.1);
}

/* [新增] */
.container {
    margin: auto;
}
.label_class {
    width: 21.8px;
    height: 23.2px;
}
.input-group {
    position: relative;
    display: table;
    border-collapse: separate;
}
.btn_signin {
    display: block;
    margin: auto;
}
.Join-NUWA-developer {
    text-align: center;
}
.input-group input {
    outline: none;
    height: 1.7em !important;
    width: 20.2em !important;
}
.checkbox_div {
    width: 20.2em !important;
}
/* 新增 */
</style>
